export const VERSION = "v3.3.29";
export const EXT_TITLE = "Webint Center";